import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, User, ShoppingBag, X, Menu, ChevronDown } from "lucide-react";
import { announcement } from "../mock";
import { COLLECTIONS as collections, BUY_ONLINE_URL } from "../data";

const Logo = () => (
  <Link to="/" className="flex items-center select-none">
    <img
      src="/maxima-logo.png"
      alt="Maxima Racing Oils"
      className="h-9 md:h-11 w-auto"
    />
  </Link>
);

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [query, setQuery] = useState("");

  const doSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      window.open(`${BUY_ONLINE_URL}?q=${encodeURIComponent(query)}`, "_blank");
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white">
      {/* Announcement bar */}
      <div className="bg-[#ED1C24] text-white text-center text-xs md:text-sm py-2 heading-font tracking-wide">
        {announcement}
      </div>

      {/* Top row */}
      <div className="relative flex items-center justify-between px-4 md:px-8 pt-5 pb-3 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <button
            aria-label="Search"
            onClick={() => setSearchOpen((v) => !v)}
            className="text-black hover:text-[#ED1C24] transition-colors"
          >
            <Search size={20} />
          </button>
          <button
            aria-label="Menu"
            className="md:hidden text-black hover:text-[#ED1C24] transition-colors"
            onClick={() => setMobileOpen((v) => !v)}
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        <div className="absolute left-1/2 -translate-x-1/2">
          <Logo />
        </div>

        <div className="flex items-center gap-4">
          <a
            href="https://www.motousher.com/account"
            target="_blank"
            rel="noreferrer"
            aria-label="Account"
            className="text-black hover:text-[#ED1C24] transition-colors"
          >
            <User size={20} />
          </a>
          <a
            href={BUY_ONLINE_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Buy Online"
            className="text-black hover:text-[#ED1C24] transition-colors"
          >
            <ShoppingBag size={20} />
          </a>
        </div>
      </div>

      {/* Search drawer */}
      {searchOpen && (
        <div className="border-b border-gray-100 px-4 md:px-8 py-3">
          <form onSubmit={doSearch} className="max-w-2xl mx-auto flex items-center gap-2">
            <Search size={18} className="text-gray-500" />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search"
              className="flex-1 outline-none py-1 heading-font tracking-wide text-sm"
            />
            <button onClick={() => setSearchOpen(false)} type="button">
              <X size={18} className="text-gray-500 hover:text-black" />
            </button>
          </form>
        </div>
      )}

      {/* Desktop nav */}
      <nav className="hidden md:flex items-center justify-center gap-8 py-3 heading-font text-sm tracking-wider">
        <Link to="/" className="nav-link">HOME</Link>
        <a href="/#segments" className="nav-link">POWERSPORTS</a>
        <div
          className="relative"
          onMouseEnter={() => setMoreOpen(true)}
          onMouseLeave={() => setMoreOpen(false)}
        >
          <button className="nav-link flex items-center gap-1">
            MORE <ChevronDown size={14} />
          </button>
          {moreOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 z-50">
              <div className="bg-white shadow-xl border border-gray-100 w-64 py-2">
                {collections.map((col) => (
                  <Link
                    key={col.slug}
                    to={`/collections/${col.slug}`}
                    className="block px-5 py-2 text-black hover:bg-gray-50 hover:text-[#ED1C24] transition-colors"
                  >
                    {col.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
        <Link to="/dealers" className="nav-link">DEALERS</Link>
        <Link to="/contact" className="nav-link">CONTACT</Link>
        <a
          href={BUY_ONLINE_URL}
          target="_blank"
          rel="noreferrer"
          className="bg-[#ED1C24] hover:bg-[#c4151c] text-white px-4 py-1.5 transition-colors"
        >
          BUY ONLINE
        </a>
      </nav>

      {/* Mobile nav */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-100 heading-font text-sm tracking-wider">
          <Link to="/" onClick={() => setMobileOpen(false)} className="block px-6 py-3 border-b border-gray-50">HOME</Link>
          <a href="/#segments" onClick={() => setMobileOpen(false)} className="block px-6 py-3 border-b border-gray-50">POWERSPORTS</a>
          <div className="px-6 py-3 border-b border-gray-50 text-gray-500 text-xs">SHOP BY SEGMENT</div>
          {collections.map((col) => (
            <Link
              key={col.slug}
              to={`/collections/${col.slug}`}
              onClick={() => setMobileOpen(false)}
              className="block px-8 py-2 text-black"
            >
              {col.name}
            </Link>
          ))}
          <Link to="/dealers" onClick={() => setMobileOpen(false)} className="block px-6 py-3 border-t border-gray-50">DEALERS</Link>
          <Link to="/contact" onClick={() => setMobileOpen(false)} className="block px-6 py-3 border-b border-gray-50">CONTACT</Link>
          <a
            href={BUY_ONLINE_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => setMobileOpen(false)}
            className="block px-6 py-3 bg-[#ED1C24] text-white"
          >
            BUY ONLINE
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
